// store.js

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// ================= SLICES =================

import authSlice from '../slice/authSlice';
import productSlice from '../slice/productSlice';
import userSlice from '../slice/userSlice';
import contactUsSlice from '../slice/contactUsSlice';
import gallerySlice from '../slice/gallerySlice';
import mediaSlice from '../slice/mediaSlice';
import enquireSlice from '../slice/enquireSlice';
import newsSlice from '../slice/newsSlice';
import schoolNotificationReducer from '../slice/schoolNotificationSlice';
import teamMessageReducer from '../slice/teamMessageSlice';
import storyReducer from '../slice/storySlice';
import categoryReducer from '../slice/categorySlice';

// ================= ROOT SAGA =================

import rootSaga from '../apis/rootSaga';

// ================= PERSIST CONFIG =================

const persistConfig = {
  key: 'root',
  storage,
  whitelist: []   // add slice name here if you want to persist
};

// ================= COMBINE REDUCERS =================

const rootReducer = combineReducers({
  auth: authSlice,
  product: productSlice,
  gallery: gallerySlice,
  media: mediaSlice,
  enquire: enquireSlice,
  user: userSlice,
  contactus: contactUsSlice,
  news: newsSlice,
  schoolNotification: schoolNotificationReducer,
teamMessage: teamMessageReducer,
  story: storyReducer,
  category: categoryReducer
});

// ================= PERSIST REDUCER =================

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ================= SAGA MIDDLEWARE =================

const sagaMiddleware = createSagaMiddleware();

// ================= CONFIGURE STORE =================

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false  // ✅ avoids FormData & persist warnings
      // thunk is enabled by default (DO NOT disable)
    }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV !== 'production'
});

// ================= RUN SAGA =================

sagaMiddleware.run(rootSaga);

// ================= PERSISTOR =================

const persistor = persistStore(store);

export { store, persistor };
